import React, { useEffect, useState } from 'react';

// Desktop-only gate per PRD §10.
//   <1024px: block the tool with a message + link back to /free-tools.
//   <640px:  same block, plus a "Continue anyway" escape hatch.
//   >=1024px: render children normally.
export default function MobileRedirect({ children }) {
  const getWidth = () =>
    typeof window === 'undefined' ? 1920 : window.innerWidth;

  const [width, setWidth] = useState(getWidth);
  const [override, setOverride] = useState(false);

  useEffect(() => {
    const onResize = () => setWidth(getWidth());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  if (override || width >= 1024) {
    return children;
  }

  const isNarrow = width < 640;

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{ background: '#F7F5EE', color: '#092825' }}
      data-testid="bta-mobile-gate"
    >
      <div className="max-w-md w-full bg-white rounded-lg border border-slate-200 shadow-sm p-8 text-center">
        <div className="text-xs uppercase tracking-wider text-[#2FA163] font-semibold mb-2">
          Free tool · I Need Numbers
        </div>
        <h1 className="text-2xl font-bold mb-3">Built for desktop</h1>
        <p className="text-slate-600 mb-6 leading-relaxed">
          This tool produces up to 4 columns of data which frankly looks like
          crap on a mobile — we&rsquo;re just trying to look out for you!
        </p>

        <a
          href="/free-tools"
          data-testid="bta-mobile-back-link"
          className="inline-block w-full bg-[#2FA163] hover:bg-[#286C4E] text-white font-semibold px-6 py-2.5 rounded shadow transition-colors"
        >
          ← Back to Free Tools
        </a>

        {isNarrow && (
          <button
            type="button"
            onClick={() => setOverride(true)}
            data-testid="bta-mobile-override-btn"
            className="mt-3 w-full text-xs text-slate-500 hover:text-slate-700 underline"
          >
            Continue anyway (layout may break)
          </button>
        )}
      </div>
    </div>
  );
}
